import useApi, { ApiOptions } from '../base/useApi';
import ScanConsultantReviewDecisionDTO from '@src/adapters/dto/scan/ScanConsultantReviewDecisionDTO';

interface Params {
  scanId: string;
  isMigrate: boolean;
}

interface Result {
  updatedItems: ScanConsultantReviewDecisionDTO[];
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/scan/decision',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveScanDecision = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useSaveScanDecisionLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveScanDecision;
